<template>
  <div style="
    height: 100%;
">
    <hshead title="产品列表" bgcolor="#fff"></hshead>
    <div class="product-ul" style="
    height: 100%;
">
      <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
        <div class="product-li" v-for="(item, index) in list" :key="index">
          <div class="left-img">
            <van-image fit="cover" width="2.2rem" height="2.2rem" :src="item.product.coverUrl" v-if="item.product.coverUrl"></van-image>
            <van-image fit="cover" width="2.2rem" height="2.2rem" :src="tempImg" v-else></van-image>
          </div>
          <div class="center-p">
            <div class="center-top">
              <div class="img-box">
                <img src="~@/assets/images/product/logo.png" alt />
              </div>
              <div class="this-p">
                {{item.product.productName}}
                <span v-if="item.ext.shootCountByMinPrice>0">×{{item.ext.shootCountByMinPrice}}张</span>
              </div>
            </div>
            <div class="center-pri" v-if="item.ext.packageMinPrice">¥{{item.ext.packageMinPrice}}</div>
            <div class="center-pri" v-else-if="item.ext.packageStatus=='1'">未配置套餐</div>
            <div class="center-pri" v-else-if="item.ext.packageStatus=='2'">套餐未生效或过期</div>
            <div class="center-pri" v-else-if="item.ext.packageStatus=='3'">套餐没有配置价格</div>
            <!-- <div class="del-pri">¥6666.00</div> -->
          </div>
          <div class="right-btn-box">
            <div class="right-btn nobg" v-if="item.product.status==2" @click="handleProductStatusBatch(item, 1)">上架</div>
            <div class="right-btn nobg" v-else-if="item.product.status==1" @click="handleProductStatusBatch(item, 2)">下架</div>
            <router-link :to="`/Store/PriceConfigs?productId=${item.product.id}`" class="right-btn">编辑</router-link>
          </div>
        </div>
      </van-list>
      <div v-if="finished" class="emptyDataDiv_gray">
        <div v-if="list.length==0">
          <van-icon name="info" />
          <p>暂无产品</p>
        </div>
        <div v-else>没有更多了</div>
      </div>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span>任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_earnings.active : icon_earnings.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <!-- <van-tabbar-item to="Grapher" icon="manager-o">
        <span>摄影师</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_cameraman.active : icon_cameraman.inactive
            "
          />
        </template>
      </van-tabbar-item> -->

      <van-tabbar-item to="Product" icon="orders-o">
        <span style="color:#304378">商品管理</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_product.active : icon_product.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Other" icon="apps-o">
        <span>更多</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_more.active : icon_more.inactive
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Toast, Image, Tabbar, TabbarItem, List, Icon, Dialog } from "vant";
import tempImg from "@/assets/images/product/tempBus.jpg";
import { getProductPager, updateProductStatusBatch } from "@/api/m/store";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//摄影师
import cameraman_icon from "@/assets/images/center/nav-3.png";
import cameraman_icon_act from "@/assets/images/center/nav-3-act.png";
//商品管理
import product_icon from "@/assets/images/center/nav-4.png";
import product_icon_act from "@/assets/images/center/nav-4-act.png";
//更多
import more_icon from "@/assets/images/center/nav-5.png";
import more_icon_act from "@/assets/images/center/nav-5-act.png";

export default {
  name: "productList",
  data() {
    return {
      tempImg: tempImg,
      list: [],
      active: 2,
      loading: false,
      finished: false,
      listQuery: {
        pn: 1,
        ps: 10,
      },
       icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_cameraman: {
        active: cameraman_icon_act,
        inactive: cameraman_icon,
      },
      icon_product: {
        active: product_icon_act,
        inactive: product_icon,
      },
      icon_more: {
        active: more_icon_act,
        inactive: more_icon,
      },
    };
  },
  methods: {
    onLoad() {
      this.getProductPager();
    },
    //产品分页查询
    getProductPager() {
      getProductPager(this.listQuery).then(response => {
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getProductPager -> data', data)
          this.listQuery.pn = this.listQuery.pn + 1
          //
          if(data.totalRecord == 0){
            this.loading = false;
            this.finished = true;
          }
          else {
            data.list.map(item => {
              this.list.push(item)
            })
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成
            if (this.list.length >= data.totalRecord) {
              this.finished = true;
            }
          }
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    // 上线、下架
    handleProductStatusBatch(row, status){
      if(row.ext.packageStatus > 0) {
        this.tips(`产品[${row.product.productName}]无价格，不能上线！`)
        return
      }
      Dialog.confirm({
        title: '提示',
        message: `确认将产品${status==1?'【上架】':'【下架】'}`
      }).then(() => {
        const tempData = [{
          Id: row.product.id,
          Status: status,
        }]
        this.load(true, '加载中...');
        updateProductStatusBatch(tempData).then((response) => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.auditFormVisible = false;
            this.tips(`产品[${status==1?'上架':'下架'}]操作成功`)
            tempData.map((item, idx) => {
              var _temp = this.list.filter(w => w.product.id == item.Id)[0]
              _temp.product.status = item.Status
            })
          }
        }).catch(response => {
          this.load(false);
          //this.tips(`${response.msg}`);
          Toast.fail({duration:1000 * 5, message: `${response.msg}`});
        });
      }).catch(() => {
        // on cancel
      });
    },
  },
  components: {
    hshead,
    "van-image": Image,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-list": List,
    "van-icon": Icon,
    [Dialog.Component.name]: Dialog.Component,
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.product-ul {
  background-color: #eef2f5;
  padding: 0.25rem (7.5-6.94rem)/2;
  padding-bottom: 1rem;
  .product-li {
    width: 6.94rem;
    height: 2.2rem;
    background-color: #ffffff;
    border-radius: 0.1rem;
    display: flex;
    margin-bottom: 0.25rem;
    .left-img {
      width: 2.2rem;
    }
    .center-p {
      width: 3.37rem;
      padding-left: 0.17rem;
      padding-top: 0.4rem;
      .center-top {
        font-family: PingFang-SC-Bold;
        font-size: 0.3rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.45rem;
        letter-spacing: 0rem;
        color: #333333;
        display: flex;
        .img-box {
          width: 0.32rem;
          height: 0.32rem;
          background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
            linear-gradient(#e2bebf, #e2bebf);
          background-blend-mode: normal, normal;
          border-radius: 50%;
          overflow: hidden;
          margin-top: 0.05rem;
          margin-right: 0.2rem;
          img {
            width: 100%;
          }
        }
        .this-p {
          flex: 1;
          font-family: PingFang-SC-Bold;
          font-size: 0.26rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.45rem;
          letter-spacing: 0rem;
          color: #333333;
          margin-bottom: 0.2rem;
          span {
            color: #999999;
          }
        }
      }
      .center-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #ff3087;
        padding-left: 0.3rem;
      }
      .del-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.2rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #999;
        text-decoration: line-through;
        padding-left: 0.3rem;
      }
    }
    .right-btn-box {
      flex: 1;
      margin-right: 0.3rem;
      .right-btn {
        width: 1.36rem;
        height: 0.4rem;
        background-color: #00b8f5;
        border-radius: 0.2rem;
        border: solid 1px #00b8f5;
        color: #ffffff;
        font-family: PingFang-SC-Medium;
        font-size: 0.22rem;
        line-height: 0.4rem;
        display: block;
        text-align: center;
        margin-top: 0.5rem;
        &.nobg {
          color: #00b8f5;
          background-color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/store/productList.vue